var map = {
	"./assets/User Invite Sample.xlsx": 6611,
	"./assets/fonts/Inter-VariableFont_opsz,wght.ttf": 3694,
	"./assets/icons/3-layers-normal.svg": 59,
	"./assets/icons/3-layers.svg": 297,
	"./assets/icons/Avatar group.svg": 8513,
	"./assets/icons/Avatar.svg": 4320,
	"./assets/icons/Illustration.svg": 4501,
	"./assets/icons/Monitor.svg": 9103,
	"./assets/icons/_Step icon base.svg": 34,
	"./assets/icons/_Step icon base_done.svg": 7493,
	"./assets/icons/_Step icon base_stationary.svg": 6103,
	"./assets/icons/arrow-down.svg": 1759,
	"./assets/icons/arrow-right.svg": 6415,
	"./assets/icons/bar-chart-2-normal.svg": 7900,
	"./assets/icons/bar-chart-2.svg": 5036,
	"./assets/icons/chat-active.svg": 7520,
	"./assets/icons/chat.svg": 8701,
	"./assets/icons/check-circle.svg": 2670,
	"./assets/icons/close.svg": 5837,
	"./assets/icons/digital.svg": 9117,
	"./assets/icons/document.svg": 152,
	"./assets/icons/effective.svg": 7642,
	"./assets/icons/ineffective.svg": 4121,
	"./assets/icons/info.svg": 6947,
	"./assets/icons/logo.svg": 6962,
	"./assets/icons/logout.svg": 4277,
	"./assets/icons/mail.svg": 9814,
	"./assets/icons/moderate.svg": 76,
	"./assets/icons/org-active.svg": 3318,
	"./assets/icons/org-inactive.svg": 7947,
	"./assets/icons/plus.svg": 4491,
	"./assets/icons/request-active.svg": 305,
	"./assets/icons/reqyest.svg": 1486,
	"./assets/icons/zap.svg": 656,
	"./assets/images/Mockup wrap.png": 2976,
	"./assets/images/herobg.mp4": 7129,
	"./assets/images/image.png": 4,
	"./components/CustomNode": 3537,
	"./components/CustomNode.tsx": 3537,
	"./components/SystemArchitecture": 4083,
	"./components/SystemArchitecture.tsx": 4083,
	"./components/SystemTestArchitecture": 1655,
	"./components/SystemTestArchitecture.tsx": 1655,
	"./components/modals/departmentmodal": 603,
	"./components/modals/departmentmodal.tsx": 603,
	"./components/modals/detailsmodal": 5665,
	"./components/modals/detailsmodal.tsx": 5665,
	"./components/modals/invitemodal": 1730,
	"./components/modals/invitemodal.tsx": 1730,
	"./components/modals/selectfilter": 410,
	"./components/modals/selectfilter.tsx": 410,
	"./components/modals/successmodal": 7038,
	"./components/modals/successmodal.tsx": 7038,
	"./components/partials/btn": 555,
	"./components/partials/btn.tsx": 555,
	"./components/partials/inputs": 7499,
	"./components/partials/inputs.tsx": 7499,
	"./components/partials/maincontainer": 9218,
	"./components/partials/maincontainer.tsx": 9218,
	"./components/partials/modalbackground": 9501,
	"./components/partials/modalbackground.tsx": 9501,
	"./components/partials/searchinput": 3780,
	"./components/partials/searchinput.tsx": 3780,
	"./components/partials/select": 3756,
	"./components/partials/select.tsx": 3756,
	"./components/partials/sidemodalcontainer": 5881,
	"./components/partials/sidemodalcontainer.tsx": 5881,
	"./components/partials/steps": 1887,
	"./components/partials/steps.tsx": 1887,
	"./components/reactflowchart/CategoryNode": 7011,
	"./components/reactflowchart/CategoryNode.tsx": 7011,
	"./components/reactflowchart/FlowCanvas": 5939,
	"./components/reactflowchart/FlowCanvas.tsx": 5939,
	"./components/reactflowchart/sampledata": 727,
	"./components/reactflowchart/sampledata.ts": 727,
	"./components/sidebar": 5421,
	"./components/sidebar/": 5421,
	"./components/sidebar/index": 5421,
	"./components/sidebar/index.tsx": 5421,
	"./components/tables": 8551,
	"./components/tables/": 8551,
	"./components/tables/SystemInformArea": 6893,
	"./components/tables/SystemInformArea.tsx": 6893,
	"./components/tables/index": 8551,
	"./components/tables/index.tsx": 8551,
	"./components/tables/requesttable": 9486,
	"./components/tables/requesttable.tsx": 9486,
	"./data/Config": 8729,
	"./data/Config.ts": 8729,
	"./data/response": 3736,
	"./data/response.ts": 3736,
	"./data/stores/authStore": 7445,
	"./data/stores/authStore.ts": 7445,
	"./data/stores/errorStore": 4167,
	"./data/stores/errorStore.ts": 4167,
	"./data/stores/loggerStore": 1131,
	"./data/stores/loggerStore.ts": 1131,
	"./data/useExtractor": 4795,
	"./data/useExtractor.tsx": 4795,
	"./data/useFetcher": 6106,
	"./data/useFetcher.tsx": 6106,
	"./pages/": 2767,
	"./pages/add-department": 6674,
	"./pages/add-department/": 6674,
	"./pages/add-department/index": 6674,
	"./pages/add-department/index.tsx": 6674,
	"./pages/dashboard": 7176,
	"./pages/dashboard.tsx": 7176,
	"./pages/department": 1472,
	"./pages/department/": 1472,
	"./pages/department/add-department": 4310,
	"./pages/department/add-department.tsx": 4310,
	"./pages/department/index": 1472,
	"./pages/department/index.tsx": 1472,
	"./pages/flow": 8963,
	"./pages/flow.tsx": 8963,
	"./pages/home": 5257,
	"./pages/home.tsx": 5257,
	"./pages/index": 2767,
	"./pages/index.tsx": 2767,
	"./pages/invitation": 5783,
	"./pages/invitation/": 5783,
	"./pages/invitation/[id]": 6950,
	"./pages/invitation/[id].tsx": 6950,
	"./pages/invitation/add-data-system": 1698,
	"./pages/invitation/add-data-system/": 1698,
	"./pages/invitation/add-data-system/[id]": 9249,
	"./pages/invitation/add-data-system/[id].tsx": 9249,
	"./pages/invitation/add-data-system/components/about-form": 7227,
	"./pages/invitation/add-data-system/components/about-form.tsx": 7227,
	"./pages/invitation/add-data-system/components/data-collection-form": 7309,
	"./pages/invitation/add-data-system/components/data-collection-form.tsx": 7309,
	"./pages/invitation/add-data-system/components/data-flow-form": 217,
	"./pages/invitation/add-data-system/components/data-flow-form.tsx": 217,
	"./pages/invitation/add-data-system/components/external-data-sharing-form": 193,
	"./pages/invitation/add-data-system/components/external-data-sharing-form.tsx": 193,
	"./pages/invitation/add-data-system/components/fit-for-purpose-form": 6232,
	"./pages/invitation/add-data-system/components/fit-for-purpose-form.tsx": 6232,
	"./pages/invitation/add-data-system/index": 1698,
	"./pages/invitation/add-data-system/index.tsx": 1698,
	"./pages/invitation/components/about": 2089,
	"./pages/invitation/components/about-edit": 1355,
	"./pages/invitation/components/about-edit.tsx": 1355,
	"./pages/invitation/components/about.tsx": 2089,
	"./pages/invitation/components/data-collection": 3243,
	"./pages/invitation/components/data-collection-edit": 7086,
	"./pages/invitation/components/data-collection-edit.tsx": 7086,
	"./pages/invitation/components/data-collection.tsx": 3243,
	"./pages/invitation/components/data-flow": 2999,
	"./pages/invitation/components/data-flow-edit": 2,
	"./pages/invitation/components/data-flow-edit.tsx": 2,
	"./pages/invitation/components/data-flow.tsx": 2999,
	"./pages/invitation/components/external-data-sharing": 8019,
	"./pages/invitation/components/external-data-sharing-edit": 2550,
	"./pages/invitation/components/external-data-sharing-edit.tsx": 2550,
	"./pages/invitation/components/external-data-sharing.tsx": 8019,
	"./pages/invitation/components/fit-for-purpose": 4736,
	"./pages/invitation/components/fit-for-purpose-edit": 6683,
	"./pages/invitation/components/fit-for-purpose-edit.tsx": 6683,
	"./pages/invitation/components/fit-for-purpose.tsx": 4736,
	"./pages/invitation/focal-person": 3128,
	"./pages/invitation/focal-person.tsx": 3128,
	"./pages/invitation/index": 5783,
	"./pages/invitation/index.tsx": 5783,
	"./pages/invitation/view-data-system": 8409,
	"./pages/invitation/view-data-system.tsx": 8409,
	"./pages/organization": 4351,
	"./pages/organization/": 4351,
	"./pages/organization/index": 4351,
	"./pages/organization/index.tsx": 4351,
	"./pages/recommendation": 1950,
	"./pages/recommendation.tsx": 1950,
	"./pages/requests": 7680,
	"./pages/requests/": 7680,
	"./pages/requests/[id]": 8859,
	"./pages/requests/[id].tsx": 8859,
	"./pages/requests/index": 7680,
	"./pages/requests/index.tsx": 7680,
	"./pages/system-inform-area": 7105,
	"./pages/system-inform-area/": 7105,
	"./pages/system-inform-area/index": 7105,
	"./pages/system-inform-area/index.tsx": 7105,
	"./pages/system-inform-area/manage-data": 27,
	"./pages/system-inform-area/manage-data.tsx": 27,
	"./pages/view-data-systems": 5438,
	"./pages/view-data-systems.tsx": 5438,
	"./redundent-cod/[id]": 9580,
	"./redundent-cod/[id].tsx": 9580,
	"./screens/flow": 3646,
	"./screens/flow.tsx": 3646,
	"./screens/login": 2840,
	"./screens/login.tsx": 2840,
	"./utils/get-currencies": 802,
	"./utils/get-currencies.ts": 802,
	"./utils/helpers": 6925,
	"./utils/helpers.ts": 6925,
	"./utils/types": 7721,
	"./utils/types.ts": 7721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6729;